@if (userProfile$ | async) {
<footer class="footer">
  @if (footerNavEnabled) {
  <div class="footer-nav" nz-row nzType="flex">
    @if (hasTranslation('footer.solutions' )) {
    <div class="footer-nav-item" nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="4" nzXl="4" nzXXl="3">
      <div class="footer-nav-item-title" translate>footer.solutions</div>
      @if (hasTranslation('footer.personalURL' )) {
      <div class="footer-nav-item-link">
        <a href="{{ 'footer.personalURL' | translate: locale.language }}" target="_blank" rel="noopener" translate>footer.personal</a>
      </div>
      } @if (hasTranslation('footer.businessURL' )) {
      <div class="footer-nav-item-link">
        <a href="{{ 'footer.businessURL' | translate: locale.language }}" target="_blank" rel="noopener" translate>footer.business</a>
      </div>
      } @if (hasTranslation('footer.pricingURL' )) {
      <div class="footer-nav-item-link">
        <a href="{{ 'footer.pricingURL' | translate: locale.language }}" target="_blank" rel="noopener" translate>footer.pricing</a>
      </div>
      }
    </div>
    } @if (hasTranslation('footer.businessPricing' )) {
    <div class="footer-nav-item" nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="3" nzXl="3" nzXXl="3">
      <div class="footer-nav-item-title" translate>footer.business</div>
      @if (hasTranslation('footer.businessPricing' )) {
      <div class="footer-nav-item-link">
        <a href="{{ 'footer.businessPricingURL' | translate: locale.language }}" target="_blank" rel="noopener" translate download>footer.businessPricing</a>
      </div>
      }
    </div>
    } @if (hasTranslation('footer.personalPricing' )) {
    <div class="footer-nav-item" nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="3" nzXl="3" nzXXl="3">
      <div class="footer-nav-item-title" translate>footer.personal</div>
      @if (hasTranslation('footer.personalPricing' )) {
      <div class="footer-nav-item-link">
        <a href="{{ 'footer.personalPricingURL' | translate: locale.language }}" target="_blank" rel="noopener" translate download>footer.personalPricing</a>
      </div>
      }
    </div>
    } @if (hasTranslation('footer.company' )) {
    <div class="footer-nav-item" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="4" nzXl="4" nzXXl="3">
      <div class="footer-nav-item-title" translate>footer.company</div>
      @if (hasTranslation('footer.teamURL' )) {
      <div class="footer-nav-item-link">
        <a href="{{ 'footer.teamURL' | translate: locale.language }}" target="_blank" rel="noopener" translate>footer.team</a>
      </div>
      } @if (hasTranslation('footer.joinUsURL' )) {
      <div class="footer-nav-item-link">
        <a href="{{ 'footer.joinUsURL' | translate: locale.language }}" target="_blank" rel="noopener" translate>footer.joinUs</a>
      </div>
      } @if (hasTranslation('footer.documentsURL' )) {
      <div class="footer-nav-item-link">
        <a href="{{ 'footer.documentsURL' | translate: locale.language }}" target="_blank" rel="noopener" translate>footer.documents</a>
      </div>
      } @if (hasTranslation('footer.contactURL' )) {
      <div class="footer-nav-item-link">
        <a href="{{ 'footer.contactURL' | translate: locale.language }}" target="_blank" rel="noopener" translate>footer.contact</a>
      </div>
      }
    </div>
    } @if (hasTranslation('footer.ecosystem' )) {
    <div class="footer-nav-item" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="4" nzXl="4" nzXXl="3">
      <div class="footer-nav-item-title" translate>footer.ecosystem</div>
      @if (hasTranslation('footer.spectrocoinURL' )) {
      <div class="footer-nav-item-link">
        <a href="{{ 'footer.spectrocoinURL' | translate: locale.language }}" target="_blank" rel="noopener" translate>footer.spectrocoin</a>
      </div>
      }
    </div>
    } @if (hasTranslation('footer.about' )) {
    <div class="footer-nav-item" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="4" nzXl="4" nzXXl="3">
      <div class="footer-nav-item-title" translate>footer.about</div>
      @if (hasTranslation('footer.legalURL' )) {
      <div class="footer-nav-item-link">
        <a href="{{ 'footer.legalURL' | translate: locale.language }}" target="_blank" rel="noopener" translate>footer.legal</a>
      </div>
      } @if (hasTranslation('footer.blogURL' )) {
      <div class="footer-nav-item-link">
        <a href="{{ 'footer.blogURL' | translate: locale.language }}" target="_blank" rel="noopener" translate>footer.blog</a>
      </div>
      }
    </div>
    }
    <div class="footer-nav-item footer-nav-item-logo" nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="8" nzXl="8" nzXXl="12">
      <div class="footer-nav-item-title">
        <app-image name="logo" (click)="navigateToAccounts()"></app-image>
      </div>
      @if (multilingual$ | async) {
      <div class="footer-nav-item-link">
        <app-lang></app-lang>
      </div>
      }
    </div>
  </div>
  } @if (hasTranslation('footer.telegramURL') && hasTranslation('footer.linkedinURL')) {
  <div class="footer-social-links">
    <a href="{{ 'footer.linkedinURL' | translate: locale.language }}" target="_blank" rel="noopener">
      <app-image name="linkedIn" [inlineSvg]="true"></app-image>
    </a>
    <a href="{{ 'footer.telegramURL' | translate: locale.language }}" target="_blank" rel="noopener">
      <app-image name="telegram" [inlineSvg]="true"></app-image>
    </a>
  </div>
  } @if (footerAdditionalInfoEnabled) {
  <div class="footer-additional-info" [innerHTML]="'footer.additionalInfo' | translate: locale.language"></div>
  } @if ( hasTranslation('footer.additionalInfoUserManual')) {
  <div class="footer-additional-info" [innerHTML]="'footer.additionalInfoUserManual' | translate: locale.language"></div>
  }
  <div class="footer-copyright">
    <div class="footer-copyright-rights" translate [params]="{ currentYear, bankName }">footer.copyrights</div>
    <div class="footer-copyright-contact" [innerHTML]="'footer.contactEmail' | translate: locale.language: { bankSupportEmail }">footer.contactEmail</div>
  </div>
</footer>
}
